import { useMergeRefs as C } from "./5GGHRIN3.js";
import { getRefProperty as R, mergeProps as P } from "./SK3NAZA3.js";
import { __spreadProps as l, __spreadValues as u, __objRest as v } from "./3YLGPPWQ.js";
import * as i from "react";
import { jsx as a } from "react/jsx-runtime";
function y(e) {
  const t = i.forwardRef((o, s) => e(l(u({}, o), { ref: s })));
  return t.displayName = e.displayName || e.name, t;
}
function S(e, t) {
  return i.memo(e, t);
}
function h(e, t) {
  const o = t, { wrapElement: s, render: n } = o, d = v(o, ["wrapElement", "render"]), x = C(t.ref, R(n));
  let m;
  if (i.isValidElement(n)) {
    const p = l(u({}, n.props), { ref: x });
    m = i.cloneElement(n, P(d, p));
  } else n ? m = n(d) : m = /* @__PURE__ */ a(e, u({}, d));
  return s ? s(m) : m;
}
function N(e) {
  const t = (o = {}) => e(o);
  return t.displayName = e.name, t;
}
function j(e = [], t = []) {
  const o = i.createContext(void 0), s = i.createContext(void 0), n = () => i.useContext(o), d = (r = !1) => {
    const c = i.useContext(s), f = n();
    return r ? c : c || f;
  }, x = () => {
    const r = i.useContext(s), c = n();
    if (!(r && r === c))
      return c;
  }, m = (r) => e.reduceRight(
    (c, f) => /* @__PURE__ */ a(f, l(u({}, r), { children: c })),
    /* @__PURE__ */ a(o.Provider, u({}, r))
  );
  return {
    context: o,
    scopedContext: s,
    useContext: n,
    useScopedContext: d,
    useProviderContext: x,
    ContextProvider: m,
    ScopedContextProvider: (r) => /* @__PURE__ */ a(m, l(u({}, r), { children: t.reduceRight(
      (c, f) => /* @__PURE__ */ a(f, l(u({}, r), { children: c })),
      /* @__PURE__ */ a(s.Provider, u({}, r))
    ) }))
  };
}
export {
  h as createElement,
  N as createHook,
  j as createStoreContext,
  y as forwardRef,
  S as memo
};
//# sourceMappingURL=VOQWLFSQ.js.map
